import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import { create } from 'ipfs-http-client';
import { NFTStorage, File } from 'nft.storage/dist/bundle.esm.min.js';
import axios from 'axios';

import AppContext from '../context/AppContext';

import CloseIcon from '@mui/icons-material/Close';

import useApi from '../hooks/useApi';
import createpostApi from '../api/createpost';

import { Loader } from './index';

import AddIcon from '@mui/icons-material/Add';
import SendIcon from '@mui/icons-material/Send';

let API_TOKEN =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweDM0MTBFMThhZUMzOGY4M2UyNTMxMzA4QmQyN0QyM0I3MjllNTJDNDUiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTY0OTQzNjM4OTkyNiwibmFtZSI6IkRBTyJ9.eWlB3VEJKUk3R1S6e5RFRhdONcgBkyCMjrWA9O5kdsA';
const client = new NFTStorage({ token: API_TOKEN });

/* Create an instance of the client */

const CreatePost = () => {
  const { theme, accountDetails } = useContext(AppContext);
  const [text, setText] = useState('');
  const [image, setImage] = useState();
  const [video, setVideo] = useState();
  const hiddenFileInput = React.useRef(null);

  const createPost = useApi(createpostApi.createPost);

  const handleClick = event => {
    hiddenFileInput.current.click();
  };
  const uploadFileHandler = async e => {
    const file = e.target.files[0];
    console.log('This is the file', file);
    if (file.type.startsWith('video')) {
      setVideo(
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      setImage();
    } else if (file.type.startsWith('image')) {
      setImage(
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      );
      setVideo();
    } else {
    }
  };
  const submitHandler = async () => {
    if (!text) {
      alert('Write what your post is about');
      return;
    }
    try {
      if (video) {
        const metadata = await client.store({
          name: 'Video',
          description: ' A video',
          image: new File([video], 'A video on VoiceDAO', {
            type: video?.type,
          }),
        });
        console.log('METADATA URL', metadata);

        createPost.request(accountDetails?.id, {
          text,
          desc: 'A Video on VoiceDAO Platform',
          video: { url: metadata?.url, type: video.type },
        });
      } else if (image) {
        const metadata = await client.store({
          name: 'Post',
          description: ' A post',
          image: new File([image], 'A post on VoiceDAO', { type: image?.type }),
        });
        console.log('METADATA URL', metadata);

        createPost.request(accountDetails?.id, {
          text,
          desc: 'A Post on VoiceDAO Platform',
          image: { url: metadata?.url, type: image?.type },
        });
      } else {
        createPost.request(accountDetails?.id, {
          text,
          desc: 'A Post on VoiceDAO Platform',
        });
      }
    } catch (error) {
      console.log('Error uploading file: ', error);
    }
  };

  useEffect(() => {
    if (createPost?.success) {
      alert('Post Created Successfully');
      setImage();
      setVideo();
      setText('');
      window.location.reload();
    }
    if (createPost?.error) {
      alert('Error creating post');
    }
  }, [createPost?.success, createPost?.error]);

  return (
    <StyledCreatePost theme_={theme}>
      <Loader visible={createPost.loading} />
      <div className="container">
        <textarea
          type="text"
          onChange={e => setText(e.target.value)}
          value={text}
          placeholder="What do you want tell the community?"
          className="input-text"
        ></textarea>
        {video && (
          <span className="video">
            <button onClick={() => setVideo()} className="cancel">
              <CloseIcon />
            </button>
            <video controls>
              <source src={video.preview} type="video/mp4" />
            </video>
          </span>
        )}
        {image && (
          <span className="img">
            <button onClick={() => setImage()} className="cancel">
              <CloseIcon />
            </button>
            <img src={image.preview} alt="img"></img>
          </span>
        )}

        <div className="footer">
          <button onClick={handleClick} className="upload">
            <AddIcon />
          </button>
          <span className="submit" onClick={submitHandler}>
            <button className="upload">
              <SendIcon />
            </button>
          </span>
        </div>
      </div>
      <input
        type="file"
        ref={hiddenFileInput}
        onChange={uploadFileHandler}
        style={{ display: 'none' }}
      />
    </StyledCreatePost>
  );
};
const StyledCreatePost = styled.div`
  padding: 0rem 2rem;

  @media screen and (max-width: 900px) {
    padding: 0rem 1rem;
  }
  .container {
    -moz-box-shadow: 0 0 3px #ccc;
    -webkit-box-shadow: 0 0 3px #ccc;
    box-shadow: 0 0 3px #ccc;
    display: flex;
    flex-flow: column wrap;
    padding: 1rem 2rem;
    border-radius: 0.5rem;
    .input-text {
      background: inherit;
      border: none;
      font-size: 1.2rem;
      outline: none;
      padding-top: 1rem;
      resize: none;
      color: ${({ theme_ }) => (theme_ ? 'white' : 'black')};
      height: auto;
    }
    .video,
    .img {
      width: 100%;
      border-radius: 0.5rem;
      position: relative;
      overflow: hidden;
      margin-top: 0.5rem;
      video {
        width: 100%;
      }
      img {
        width: 100%;
      }
      transition: 2s ease-in-out;
      .cancel {
        padding: 0.5rem;
        border-radius: 0.5rem;
        position: absolute;
        top: 2%;
        left: 2%;
        z-index: 2;
        cursor: pointer;
        display: none;
        background-color: rgba(31, 32, 41, 0.75);
      }
      &:hover {
        .cancel {
          display: block;
        }
      }
    }
    .img {
    }
    .footer {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      padding: 0rem 0rem;
      button {
        font-size: 1.5rem;
        padding: 0rem 0rem;
      }
      .upload {
        background: inherit;
        color: #76be02;

        font-size: 2rem;
      }
    }
  }
`;
export default CreatePost;
